import { createContext } from "react";

import { PaymentViewHelper } from "./PaymentViewHelper.ts";

export const PaymentViewContext = createContext<PaymentViewHelper>(
  {} as PaymentViewHelper
);
